import FJVideoSettings from './FJVideoSettings';
import { useSelector, useDispatch } from 'react-redux';
import FJActionTextToVideo from '../../../redux/action/FJActionTextToVideo';
import useLocalStore from '../../../hooks/useLocalStore';
import FJAppConstant from '../../../constants/FJAppConstant';
import { useMemo, useLayoutEffect, useEffect } from 'react';
import FJUtil from '../../../util/FJUtil';
import FJConstant from '../../../constants/FJConstant';
import { setSliceTotalCredit } from '../../../redux/slices/FJSliceTextToVideo';
import FJEvent from '../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
const FJVideoSettingsContainer = () => {
    useLocalStore();
    const selectTab = useSelector(state => state.textToVideo.selectTab);
    const freeNumCreationInfo = useSelector(state => state.textToVideo.freeNumCreationInfo);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const sceneTextList = useSelector(state => state.textToVideo.sceneTextList);
    const voiceSettingActive = useSelector(state => state.textToVideo.voiceSettingActive);
    const mediaSource = useSelector(state => state.textToVideo.mediaSource);
    const spiderData = useSelector(state => state.textToVideo.spiderData);
    const useSpiderImage = useSelector(state => state.textToVideo.useSpiderImage);
    const dispatch = useDispatch();
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);
    useLayoutEffect(() => {
        if (textToVideoStep === FJConstant.STEP_TYPE_VIDEO_SETTINGS) {
            FJEvent.dispatch(FJ_EVENT_TYPE.UPDATE_SWIPER_VIEW);
        }
    }, [textToVideoStep, dispatch]);
    const onGenerate = () => {
        dispatch(FJActionTextToVideo.onGenerateVideoAction());
    };

    const isShowImageSetting = useMemo(() => {
        return selectTab !== FJAppConstant.PPT_TO_VIDEO;
    }, [selectTab]);

    const freeTimes = useMemo(() => {
        switch (selectTab) {
            case FJAppConstant.TEXT_TO_FULL_VIDEO:
                return freeNumCreationInfo.textToFullVideo;
            case FJAppConstant.BLOG_URL_TO_VIDEO:
                return freeNumCreationInfo.blogUrlToVideo;
            case FJAppConstant.PRODUCT_URL_TO_VIDEO:
                return freeNumCreationInfo.productUrlToVideo;
            case FJAppConstant.PPT_TO_VIDEO:
                return freeNumCreationInfo.pptToVideo;
            default:
                return 0;
        }
    }, [freeNumCreationInfo, selectTab]);
    const needGenerateImageNum = useMemo(() => {
        if (mediaSource === FJConstant.STOCK_LIBRARY) {
            return 0;
        }
        switch (selectTab) {
            case FJAppConstant.TEXT_TO_FULL_VIDEO:
                return sceneTextList.filter(item => !!item.text.trim()).length;
            case FJAppConstant.BLOG_URL_TO_VIDEO:
                return Math.max(
                    sceneTextList.filter(item => !!item.text.trim()).length -
                        (useSpiderImage ? spiderData.images.length : 0),
                    0,
                );
            case FJAppConstant.PRODUCT_URL_TO_VIDEO:
            case FJAppConstant.PPT_TO_VIDEO:
                return 0;
            default:
                return 0;
        }
    }, [sceneTextList, spiderData, selectTab, mediaSource, useSpiderImage]);
    const useCreditInfo = useMemo(() => {
        const deductType = FJActionTextToVideo.getDeductType(selectTab);
        const option = {
            freeNumCreationInfo,
            creditNumber,
            type: deductType,
            textToSpeechUseLength: voiceSettingActive
                ? FJUtil.getTextLength(sceneTextList.reduce((calc, cur) => calc + cur.text, ''))
                : 0,
            mediaMatch: mediaSource === FJConstant.STOCK_LIBRARY,
            generateImageNum: needGenerateImageNum,
        };
        const quotaInfo = FJActionTextToVideo.getQuotaInfo(option);
        return quotaInfo;
    }, [
        freeNumCreationInfo,
        creditNumber,
        voiceSettingActive,
        sceneTextList,
        mediaSource,
        needGenerateImageNum,
        selectTab,
    ]);
    useEffect(() => {
        const { useCredits } = useCreditInfo;
        dispatch(setSliceTotalCredit(useCredits));
    }, [useCreditInfo, dispatch]);
    return (
        <FJVideoSettings
            freeTimes={freeTimes}
            onGenerate={onGenerate}
            isShowImageSetting={isShowImageSetting}
            useCreditInfo={useCreditInfo}
            creditNumber={creditNumber}
            mediaSource={mediaSource}
            selectTab={selectTab}
        />
    );
};

export default FJVideoSettingsContainer;
